





































































import { Vue, Component, Watch, Prop } from "@/shared/vuepack";
import { ToHome } from "@/shared/route-names";
import { PartnerEmployer, PartnerEmployerStatus } from "@/employer/types";
import CurrentEmployer from "./CurrentEmployer.vue";
import AccountAlertBellCobrand from "@/shared/components/accountAlert/AccountAlertBellCobrand.vue";
import Logo from "@/shared/components/Logo.vue";
import { PartnerHome, EmployerHome, PartnerSecurity, PartnerEmployeeSearch } from "@/employer/route-names";
import EnrollmentStatus from "@/employer/components/shared/EnrollmentStatus.vue";
import Swinger from "@/employer/components/shared/Swinger.vue";
import AccountHolderDisplayName from "@/employer/components/partner-ee-service/AccountHolderDisplayName.vue";
import AccountHolderHoldsAlert from "@/employer/components/partner-ee-service/AccountHolderHoldsAlert.vue";
import { isPartnerPage } from "@/employer/navSelector";
import { useUserStore } from "@/shared/store/user";
import { useNavigationStore } from "@/shared/store/navigation";
import { useImpersonatorStore } from "@/shared/store/impersonator";
import { usePartnerStore } from "@/employer/store/partner";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useRoleStore } from "@/shared/store/role";

@Component({
  components: {
    CurrentEmployer,
    AccountAlertBellCobrand,
    Logo,
    Swinger,
    AccountHolderDisplayName,
    EnrollmentStatus,
    AccountHolderHoldsAlert
  }
})
export default class Header extends Vue {
  userStore = useUserStore();
  navigationStore = useNavigationStore();
  impersonatorStore = useImpersonatorStore();
  partnerStore = usePartnerStore();
  custodianSettingsStore = useCustodianSettingsStore();
  roleStore = useRoleStore();

  @Prop()
  partnerHeaderMode: {
    showCustomerServiceHeader: boolean;
    showEmployerNameHeader: boolean;
  };

  navOpen = false;
  profileTabOpen = false;
  ToHome = ToHome;
  isLoadingEmployer = false;

  mounted (): void {
    if (this.showBackToPartnerHomeERName) {
      this.loadEmployer();
    }
    this.roleStore.getPartnerRoles();
    this.roleStore.getEmployerRoles();
  }

  @Watch("userStore.employerId")
  loadEmployer () {
    if (this.userStore.employerId && this.showBackToPartnerHomeERName) {
      this.isLoadingEmployer = true;
      this.partnerStore.loadEmployerByEmployerId(
        {
          partnerId: this.userStore.partnerId,
          employerId: this.userStore.employerId
        }).finally(() => {
          this.isLoadingEmployer = false;
        });
    }
  }

  @Watch("$route", { immediate: true, deep: true })
  onUrlChange (newRoute) {
    const PARAM_PARTNERID = "partnerId";
    const parsedPartnerId = Number(newRoute.params.partnerId);
    if (newRoute.params[PARAM_PARTNERID] &&
      this.userStore.partnerId !== parsedPartnerId) {
      this.userStore.changePartner(parsedPartnerId);
    }
  }

  routeToHome () {
    if (this.userStore.partnerId) {
      return this.routeToPartnerHome();
    }

    return this.routeEmployerToHome();
  }

  routeEmployerToHome () {
    return { name: EmployerHome, params: { employerId: this.userStore.employerId } };
  }

  routeToPartnerHome (override = false) {
    let dest = PartnerHome;
    if (override) {
      dest = this.navigationStore.lastPartnerPortalTab === PartnerEmployeeSearch ? PartnerEmployeeSearch : PartnerHome;
    }
    return { name: dest, params: { partnerId: this.userStore.partnerId } };
  }

  routeToPartnerSecurity () {
    return { name: PartnerSecurity, params: { partnerId: this.userStore.partnerId } };
  }

  get employerName () { return this.userStore.currentEmployer && this.userStore.currentEmployer.employerName; }

  get showBackToPartnerHome () {
    return this.showBackToPartnerHomeERName || this.showBackToPartnerHomeEEName;
  }

  get showBackToPartnerHomeERName () {
    return this.partnerHeaderMode && this.partnerHeaderMode.showEmployerNameHeader;
  }

  get showBackToPartnerHomeEEName () {
    return this.partnerHeaderMode && this.partnerHeaderMode.showCustomerServiceHeader;
  }

  get usePartnerNavigation () {
    return isPartnerPage(this.$route.name);
  }

  get displayEnrollmentStatus (): boolean {
    return this.showBackToPartnerHomeERName && this.partnerStore.partnerEmployerLoaded(this.userStore.employerId);
  }

  get hasPartnerRoles (): boolean {
    return this.userStore.currentPartner && this.userStore.currentPartner.partnerUserRoles.length > 0;
  }

  get hasEmployerRoles (): boolean {
    return this.userStore.currentEmployer && this.userStore.currentEmployer.employerUserRoles.length > 0;
  }

  get partnerRoles (): string[] {
    if (this.userStore.currentPartner && this.roleStore.hasPartnerRoles) {
      return this.userStore.currentPartner.partnerUserRoles.map(p => {
        const role = this.roleStore.partnerRoles.find(r => r.roleId === p);
        if (role) {
          return role.displayName ? role.displayName : role.roleName;
        }
      });
    }
    return [];
  }

  get employerRoles (): string[] {
    if (this.userStore.currentEmployer && this.roleStore.hasEmployerRoles) {
      return this.userStore.currentEmployer.employerUserRoles.map(p => {
        const role = this.roleStore.employerRoles.find(r => r.roleId === p);
        if (role) {
          return role.displayName ? role.displayName : role.roleName;
        }
      });
    }
    return [];
  }

  toggleNav () {
    this.navigationStore.toggleMobileMenu();
  }

  toggleProfileMenu () {
    this.profileTabOpen = !this.profileTabOpen;
  }

  onSwingerClick () {
    this.profileTabOpen = !this.profileTabOpen;
  }

  get displayInitials () {
    if (!this.userStore.currentUser.firstName || !this.userStore.currentUser.lastName) {
      // Whatever the default initials should be if you don't have a name
      return "NA";
    }

    return `${this.userStore.currentUser.firstName[0]}${this.userStore.currentUser.lastName[0]}`;
  }

  get displayName () {
    if (!this.userStore.currentUser.displayName.trim()) {
      return "New User";
    }

    return this.userStore.currentUser.displayName;
  }

  get impersonatedUserFullName () {
    return this.impersonatorStore.impersonatedName;
  }

  get partnerEmployer (): PartnerEmployer {
    const employer = this.partnerStore.selectedEmployerByEmployerId(this.userStore.employerId);
    return employer;
  }

  get isEmployerDisabled (): boolean {
    return (this.partnerEmployer && (this.partnerEmployer.isTerminated
      || this.partnerEmployer.status === PartnerEmployerStatus.Suspended));
  }

  get employerStatusText (): string {
    if (this.partnerEmployer && this.partnerEmployer.isTerminated) {
      return "Terminated";
    }

    const { status } = this.partnerEmployer;

    switch (status) {
      case PartnerEmployerStatus.Suspended:
        return "Suspended";
      case PartnerEmployerStatus.UmbAccountCreationComplete:
      case PartnerEmployerStatus.EmployeeInviteEmailComplete:
        return "Active";
      default:
        return "Pending";
    }
  }

  get employerStatusType (): string {
    if (this.partnerEmployer && this.partnerEmployer.isTerminated) {
      return "blocked";
    }

    const { status } = this.partnerEmployer;

    switch (status) {
      case PartnerEmployerStatus.Suspended:
        return "blocked";
      case PartnerEmployerStatus.UmbAccountCreationComplete:
      case PartnerEmployerStatus.EmployeeInviteEmailComplete:
        return "enrolled";
      default:
        return "ineligible";
    }
  }

  get bankAccountHoldsVisible (): boolean {
    return this.custodianSettingsStore.displayBankAccountHolds;
  }
}
